import React from "react";

const headerData = {
  title: "Building Made Easy, Bulk Made Simple",
  paragraph:
    "Connecting builders, contractors, and suppliers through a seamless online platform for bulk construction material orders. Get the best prices, reliable sourcing, and hassle-free delivery—all in one place.",
};

export const Header = () => {
  return (
    <header id="header" className="position-relative">
      <div className="intro d-flex align-items-center vh-100 text-start">
        <div className="overlay w-100 h-100 position-absolute top-0 start-0"></div>
        <div className="container position-relative">
          <div className="row g-0">
            <div className="col-md-6">
              <div className="intro-text">
                <h1>{headerData.title}</h1>
                <p>{headerData.paragraph}</p>
                <a href="/login" className="btn btn-primary btn-lg">
                  Login Here
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
